<div class="background-shader" (click)="close()"></div>

<div
  #dropdownWindow
  class="dropdown-window"
  [class.on-top]="isOnTop"
  (mouseenter)="focus($event)"
  (mouseleave)="blur($event)"
>
  <!-- prettier-ignore -->
  <!--  -->
  <div *ngIf="addNewOption" class="option add-new-option" (click)="onAddNewOption($event, 'Add New')" >
    <div class="label">
      <span class="add-icon">+</span>
      <span>{{ 'FINANCE_DROPDOWN.ADD_NEW_OPTION' | translate }}</span>
    </div>
  </div>
  <div class="scrollable-container">
  

  

  <ng-container
    *ngFor="
      let option of ignoreSort
        ? optionItems
        : (optionItems | orderBy : '' : false : 'case-insensitive');
      let last = last;
      index as i
    "
  >
    <div
      #option
      class="option {{ getCustomClassForIndex(i) }}"
      (click)="onSelectValue($event, option)"
      (keyup)="onKeypress($event, option)"
      [class.last]="last && deleteOption === ''"
      id="{{ i + 1 + startingFocusIndex }}"
      tabindex="-1"
    >
      <div class="checks" *ngIf="checkedImg || uncheckedImg">
        <img
          src="{{ uncheckedImg }}"
          *ngIf="uncheckedImg && !selectedValues.includes(option)"
        />
        <img
          src="{{ checkedImg }}"
          *ngIf="checkedImg && selectedValues.includes(option)"
        />
      </div>

      <div class="label" [class.red]="option?.toUpperCase().includes('DELETE')">
        <!-- {{ option }} -->
        {{ option | translate }}
      </div>
    </div>
  </ng-container>

  <div
    #option
    *ngIf="deleteOption !== ''"
    class="option last"
    (click)="onSelectValue($event, deleteOption)"
    (keyup)="onKeypress($event, deleteOption)"
    id="{{ optionItems.length + 1 + startingFocusIndex }}"
    tabindex="-1"
  >
    <div class="checks" *ngIf="checkedImg || uncheckedImg">
      <img
        src="{{ uncheckedImg }}"
        *ngIf="uncheckedImg && !selectedValues.includes(deleteOption)"
      />
      <img
        src="{{ checkedImg }}"
        *ngIf="checkedImg && selectedValues.includes(deleteOption)"
      />
    </div>
    <div class="label red">
      {{ deleteOption | translate }}
    </div>
  </div>

  <div
    #option
    *ngIf="editedByFullName"
    class="option no-action-no-wrap"
    id="{{ optionItems.length + 2 + startingFocusIndex }}"
    tabindex="-1"
  >
    <div class="label">
      <span>Last Edited By:</span>
      {{ editedByFullName }}
      <br />
      {{ editedBy.date | date : 'dd.MM.yyyy' }}
      </div>
    </div>
  </div>
</div>
<div
  #modalBackground
  class="background"
  (click)="closeFromBackground($event)"
  (mousewheel)="closeOnScroll && closeFromBackground($event)"
></div>
